import { Button, Container, makeStyles, Typography } from "@material-ui/core";
import { Edit, Save } from "@material-ui/icons";
import { Formik } from "formik";
import React, { useContext, useState } from "react";
import { AuthContext } from "../../Auth/AuthContextProvider";
import EditProfile from "./EditProfile";
import UserService from "../../Base/Services/UserService";
import useAlerts from "../../Base/AlertProvider";
import { Prompt } from "react-router";

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 700,
    marginTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  inlineIcon: { marginRight: theme.spacing(1) },
}));

export default function UserEditProfile() {
  const classes = useStyles();
  const authContext = useContext(AuthContext);
  const [editing, setEditing] = useState(false);
  const { addSuccessAlert, addErrorAlert } = useAlerts();

  function handleSubmit(values) {
    const userToUpdateValues = { ...authContext.userInfo, contactInformation: { ...values } };
    UserService.updateUser(userToUpdateValues)
      .then((updatedUserInfo) => {
        authContext.setUserInfo(updatedUserInfo);
        addSuccessAlert("Information Saved");
      })
      .catch(() => addErrorAlert("An error occurred while saving"))
      .finally(() => setEditing(false));
  }

  const contactInfo = authContext.userInfo.contactInformation;
  const initialValues = {
    firstName: contactInfo.firstName ?? "",
    middleName: contactInfo.middleName ?? "",
    lastName: contactInfo.lastName ?? "",
    phone: contactInfo.phone ?? "",
    email: contactInfo.email ?? "",
    streetAddress1: contactInfo.streetAddress1 ?? "",
    streetAddress2: contactInfo.streetAddress2 ?? "",
    city: contactInfo.city ?? "",
    state: contactInfo.state ?? "",
    zipCode: contactInfo.zipCode ?? "",
    country: contactInfo.country ?? "",
  };

  return (
    <Container className={classes.root} role="main">
      <Typography variant="h2">My Profile</Typography>
      <Formik initialValues={initialValues}>
        {(formik) => (
          <>
            <Prompt
              when={Boolean(editing && formik.dirty)}
              message={"Are you sure you want to leave? Your changes may not be saved."}
            />
            <fieldset disabled={editing ? "" : "disabled"} style={{ border: "none" }}>
              <EditProfile />
            </fieldset>
            <div style={{ width: "100%", display: "flex", justifyContent: "flex-end" }}>
              {editing ? (
                <Button
                  onClick={() => {
                    handleSubmit(formik.values);
                  }}
                  variant="contained"
                  color="primary"
                >
                  <Save className={classes.inlineIcon} /> Save
                </Button>
              ) : (
                <Button onClick={() => setEditing(true)} variant="contained">
                  <Edit className={classes.inlineIcon} /> Edit Information
                </Button>
              )}
            </div>
          </>
        )}
      </Formik>
    </Container>
  );
}
